// Vue + components
import Vue from 'vue'; // TODO - compile templates + fix this shit.
import VueRouter from 'vue-router';

import { ValidationObserver , ValidationProvider, extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules.umd.js';
import { setInteractionMode } from 'vee-validate';
setInteractionMode('eager');

import VueCarousel from 'vue-carousel';
import VueAgile from 'vue-agile/dist/VueAgile.umd';
import Vue2TouchEvents from 'vue2-touch-events'
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import mia from '../services/MIAPreviewAPI';
const miaplugin = {
    install() {
        Vue.mia = mia;
        Vue.prototype.$mia = mia;
    }
}

//fa-chevron-circle-right

import { library } from '@fortawesome/fontawesome-svg-core'

import { 
    faTimes,
    faBars,
    faChevronCircleRight,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronCircleLeft,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faInfo,
    faQuestionCircle,
    faCheckCircle,
} from '@fortawesome/free-solid-svg-icons'

import {
    faTimesCircle,
    faPlayCircle,
    faArrowAltCircleRight,
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faTimes,
    faBars,
    faChevronCircleRight,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronCircleLeft,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faInfo,
    faQuestionCircle,
    faTimesCircle,
    faCheckCircle,
    faPlayCircle,
    faArrowAltCircleRight,
);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('agile', VueAgile);

extend('required', required);
//extend('email', email);
extend('min', min);

extend('email-required', Object.assign(required, { message: 'Ai! Email vergeten.' }));
extend('pass-required', Object.assign(required, { message: 'Wachtwoord vergeten...' }));
extend('email', Object.assign(email, { message: 'Mhhh, is dat een geldig emailadres?' }));

extend('pass-min-6', value => {
    if(value.length >= 6) {
        return true;
    }

    return 'Heb je 6 karakters gebruikt voor je W8W?';
})

extend('pass-strong', value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})");
    if (strongRegex.test(value)) {
        return true;
    }

    return 'Voor je W8W heb je minimaal 6 karakters nodig, een hoofdletter, kleine letter en een speciaal teken?';
})

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

/* @ifdef SENTRY_ENDPOINT_URL */
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { RewriteFrames } from '@sentry/integrations';

Sentry.init({
  dsn: '/* @echo SENTRY_ENDPOINT_URL */',
  release: 'mkbidee-live',
  integrations: [
    new VueIntegration({Vue, attachProps: true, logErrors: /* @ifdef DEBUG */ true || /* @endif */ false}),
    new RewriteFrames()
  ],
});

/* @endif */

Vue.use(miaplugin);
Vue.use(VueCarousel);
Vue.use(VueAgile);
Vue.use(VueRouter);

Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    touchHoldTolerance: 400,
    swipeTolerance: 30,
    longTapTimeInterval: 400
})
Vue.use(Vuex);
Vue.use(VueCookies);

// Expire after 31 days
Vue.$cookies.config(('31d'));

export default Vue;